import { queryOptions, useQuery } from '@tanstack/react-query'
import { AppError } from '@shared/api/error'
import { apiFetch } from '@shared/api/http'
import { CoproductionInviteSchema } from './coproduction.contract'
import type { CoproductionInvite } from './coproduction.contract'

export const coproductionKeys = {
  forProduct: (productId: string) => ['partnerships', 'coproductions', productId] as const,
  mine: () => ['partnerships', 'coproductions', 'mine'] as const,
}

function isNotFound(error: unknown) {
  return error instanceof AppError && error.status === 404
}

export async function getCoproductionForProduct(
  productId: string,
): Promise<CoproductionInvite | null> {
  try {
    const data = await apiFetch<unknown>(`/partnerships/products/${productId}/coproduction`)
    if (data === null || data === undefined) {
      return null
    }
    return CoproductionInviteSchema.parse(data)
  } catch (error) {
    if (isNotFound(error)) {
      return null
    }
    throw error
  }
}

export function coproductionForProductQuery(productId: string) {
  return queryOptions({
    queryKey: coproductionKeys.forProduct(productId),
    queryFn: () => getCoproductionForProduct(productId),
    enabled: Boolean(productId),
  })
}

export function useCoproductionForProductQuery(productId: string | undefined) {
  return useQuery(coproductionForProductQuery(productId ?? ''))
}

export async function getMyCoproductions(): Promise<CoproductionInvite[]> {
  const data = await apiFetch<unknown>('/partnerships/coproductions/mine')
  return CoproductionInviteSchema.array().parse(data)
}

export function myCoproductionsQuery() {
  return queryOptions({
    queryKey: coproductionKeys.mine(),
    queryFn: getMyCoproductions,
  })
}

export function useMyCoproductionsQuery() {
  return useQuery(myCoproductionsQuery())
}
